import { IconButton, useTheme } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectStatusFilter,
  selectWorkOrderStatusLabelKey,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import {
  WorkOrderStatusFilter,
  WORK_ORDER_STATUS_VALUES,
} from "../../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick: () => void;
};

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const statusFilter = useSelector(selectStatusFilter);

  const getStatusLabel = (value: WorkOrderStatusFilter) =>
    t(selectWorkOrderStatusLabelKey(value));

  const getStatusColor = (value: WorkOrderStatusFilter) =>
    value === "ALL" ? "" : theme.palette.workOrderStatus[value];

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton label={t("WORK_ORDER.ADD")} onClick={onAddClick} />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <FilterSelect
        multiple
        label={t("WORK_ORDER.STATUS_FILTER")}
        value={statusFilter}
        options={["ALL", ...WORK_ORDER_STATUS_VALUES]}
        getOptionLabel={getStatusLabel}
        getOptionColor={getStatusColor}
        menuMaxHeight={372}
        onChange={(value) => dispatch(actions.setStatusFilter(value))}
      />
    </div>
  );
};

export default ActionBar;
